<router-outlet></router-outlet>

<!--<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Factura Template</title>
</head>
<body style=" background-color: #f5f5f5; margin: 0px; padding: 0px; top:36px">
  <div style="background-color: #fff; border-radius: 12px 12px 0px 0px; box-shadow: 0 0 10px rgba(0, 0, 0, 0.1) ">

    <div style="padding: 10px; background-color: #B3D1E2; border-radius: 12px 12px 0px 0px; ">
      <table style="border-spacing: 0; width: 100%;  border-collapse: collapse;">
        <tr style="padding: 30px">
          <td style="vertical-align: middle; text-align: left;">
            <img style="height: 100px;" src="/assets/Recurso14LogoVestaVertical1.png" />
          </td>

          <td style="vertical-align: middle; text-align: right;">
            <img style="height: 100px;" src="/assets/logoFibonacci.png" />
          </td>
        </tr>
      </table>
    </div>


    <div style="background-color: #F5F5F5; padding: 10px">
      <span style="font-family: Calibri; font-size: 40px; font-weight: 400; line-height: 48px; letter-spacing: 0.02em; text-align: left; color: #011C73; padding-left: 15px;">Notificación de Eventos</span>

      <a href="https://controlfinanciero.vesta-accelerate.com/" style="text-decoration: none; box-shadow: 0px 4px 12px 0px #00000040; background-color: #FFFFFF; border-radius: 8px; font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; text-align: left; padding: 12px; text-align: center; display: inline-block; width: auto; float: right">
        <span style="color: #E93636;">Ir al Sistema</span>
      </a>
    </div>

    <div style=" padding-left: 13px;">

      <table style="width: 100%; border-collapse: collapse;">
        <tr>
          <td style="padding: 10px; vertical-align: top;">
            <div style="display: flex;">
              <div style="width:20%"><span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: left; color: #2E3135;">Evento</span></div>
              <div><span style="color: #757575; font-family: Calibri; font-size: 18px; font-weight: 700; line-height: 21.6px; letter-spacing: 0.02em; text-align: left;">Falta de energía eléctrica</span></div>

            </div>
          </td>

        </tr>
        <tr>
          <td style="padding: 10px; vertical-align: top;">

            <div style="display: flex;">
              <div style="width:20%"><span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: left; color: #2E3135;">Sitio</span></div>
              <div><span style="color: #757575; font-family: Calibri; font-size: 18px; font-weight: 700; line-height: 21.6px; letter-spacing: 0.02em; text-align: left;">ADUANA LA MESA</span></div>

            </div>
          </td>

        </tr>
        <tr>
          <td style="padding: 10px; vertical-align: top;">
            <div style="display: flex;">
              <div style="width:20%"><span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: left; color: #2E3135;">Inicio Evento</span></div>
              <div><span style="color: #757575; font-family: Calibri; font-size: 18px; font-weight: 700; line-height: 21.6px; letter-spacing: 0.02em; text-align: left;">11/04/2025 17:19:00 PM</span></div>

            </div>
          </td>

        </tr>
        <tr>
          <td style="padding: 10px; vertical-align: top;">
            <div style="display: flex;">
              <div style="width:20%"><span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: left; color: #2E3135;">Creado por</span></div>
              <div><span style="color: #757575; font-family: Calibri; font-size: 18px; font-weight: 700; line-height: 21.6px; letter-spacing: 0.02em; text-align: left;">JOSE CARLOS HERNANDEZ SOSA</span></div>

            </div>
          </td>

        </tr>
        <tr>
          <td style="padding: 10px; vertical-align: top;">
            <div style="display: flex;">
              <div style="width:20%"><span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: left; color: #2E3135;">Sello Detonante</span></div>
              <div><span style="color: #757575; font-family: Calibri; font-size: 18px; font-weight: 700; line-height: 21.6px; letter-spacing: 0.02em; text-align: left;">Entrada</span></div>

            </div>
          </td>

        </tr>
      </table>
    </div>
    <br />
    <br />
    <table style="border-collapse: collapse; width: 100%">
      <tr>
        <td>
          <div style="padding-left: 15px;"><span style="font-family: Calibri; font-size: 24px; font-weight: 600; line-height: 28.8px; letter-spacing: 0.02em; text-align: left; color: #3B3B3B; ">Gestiones Afectadas</span></div>
        </td>
      </tr>
    </table>
    <div style="padding-right: 15px; padding-left: 15px; border-radius: 8px;">
      <table style=" width: 100%; margin-bottom: 20px;  border-collapse: collapse;">
        <thead style="border: none; background-color: #011C73; padding: 10px">
          <tr>
            <th style="height: 50px"><span style="font-family: Calibri; font-size: 18px; font-weight: 700; line-height: 21.6px; letter-spacing: 0.02em; text-align: center; color: white;">Gestión</span></th>
            <th style="height: 50px"><span style="font-family: Calibri; font-size: 18px; font-weight: 700; line-height: 21.6px; letter-spacing: 0.02em; text-align: center; color: white;">Hoja de Ruta</span></th>
            <th style="height: 50px"><span style="font-family: Calibri; font-size: 18px; font-weight: 700; line-height: 21.6px; letter-spacing: 0.02em; text-align: center; color: white;">Referencia Cliente</span></th>
            <th style="height: 50px"><span style="font-family: Calibri; font-size: 18px; font-weight: 700; line-height: 21.6px; letter-spacing: 0.02em; text-align: center; color: white;">Factura</span></th>
            <th style="height: 50px"><span style="font-family: Calibri; font-size: 18px; font-weight: 700; line-height: 21.6px; letter-spacing: 0.02em; text-align: center; color: white;">Proveedor</span></th>
            <th style="height: 50px"><span style="font-family: Calibri; font-size: 18px; font-weight: 700; line-height: 21.6px; letter-spacing: 0.02em; text-align: center; color: white;">Producto</span></th>
            <th style="height: 50px"><span style="font-family: Calibri; font-size: 18px; font-weight: 700; line-height: 21.6px; letter-spacing: 0.02em; text-align: center; color: white;">Destino</span></th>
            <th style="height: 50px"><span style="font-family: Calibri; font-size: 18px; font-weight: 700; line-height: 21.6px; letter-spacing: 0.02em; text-align: center; color: white;">Doc. de Embarque</span></th>
            <th style="height: 50px"><span style="font-family: Calibri; font-size: 18px; font-weight: 700; line-height: 21.6px; letter-spacing: 0.02em; text-align: center; color: white;">Placa</span></th>
            <th style="height: 50px"><span style="font-family: Calibri; font-size: 18px; font-weight: 700; line-height: 21.6px; letter-spacing: 0.02em; text-align: center; color: white;">Proveedor de Transporte</span></th>
            <th style="height: 50px"><span style="font-family: Calibri; font-size: 18px; font-weight: 700; line-height: 21.6px; letter-spacing: 0.02em; text-align: center; color: white;">Motorista</span></th>
            <th style="height: 50px"><span style="font-family: Calibri; font-size: 18px; font-weight: 700; line-height: 21.6px; letter-spacing: 0.02em; text-align: center; color: white;">Contenedores</span></th>
            <th style="height: 50px"><span style="font-family: Calibri; font-size: 18px; font-weight: 700; line-height: 21.6px; letter-spacing: 0.02em; text-align: center; color: white;">Aduana Operativa</span></th>
            <th style="height: 50px"><span style="font-family: Calibri; font-size: 18px; font-weight: 700; line-height: 21.6px; letter-spacing: 0.02em; text-align: center; color: white;">Arribo</span></th>
            <th style="height: 50px"><span style="font-family: Calibri; font-size: 18px; font-weight: 700; line-height: 21.6px; letter-spacing: 0.02em; text-align: center; color: white;">Gate Pass</span></th>
          </tr>
        </thead>
        <tbody>
          <tr style="border-bottom: 1px solid #ddd; height:50px">
            <td>
              <span style="font-family: Calibri; font-size: 16px; font-weight: 400; line-height: 19.2px; letter-spacing: 0.02em; text-align: left; color: #3B3B3B;">PR-CH-23-1971</span><br />
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; color: #3B3B3B; font-size: 14px; font-weight: 500; line-height: 16.8px; letter-spacing: 0.02em; text-align: right;">CH-CH-H23-3540</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; color: #3B3B3B; font-size: 14px; font-weight: 500; line-height: 16.8px; letter-spacing: 0.02em; text-align: right;">XXX</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">756481</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; color: #3B3B3B; font-size: 14px; font-weight: 500; line-height: 16.8px; letter-spacing: 0.02em; text-align: right;">Devro, Inc</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">XXX</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">CARGILL DE HONDURAS</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">XXX</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">N-1831</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">ALCON</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">XXX</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">N/A</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">ADUANA LA MESA</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">07/10/2023 16:16:59 PM</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">XXX</span>
            </td>
          </tr>
          <tr style="border-bottom: 1px solid #ddd; background-color: #F5F5F5; height: 50px ">
            <td>
              <span style="font-family: Calibri; font-size: 16px; font-weight: 400; line-height: 19.2px; letter-spacing: 0.02em; text-align: left; color: #3B3B3B;">PR-CH-23-1971</span><br />
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; color: #3B3B3B; font-size: 14px; font-weight: 500; line-height: 16.8px; letter-spacing: 0.02em; text-align: right;">CH-CH-H23-3540</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; color: #3B3B3B; font-size: 14px; font-weight: 500; line-height: 16.8px; letter-spacing: 0.02em; text-align: right;">XXX</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">756481</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; color: #3B3B3B; font-size: 14px; font-weight: 500; line-height: 16.8px; letter-spacing: 0.02em; text-align: right;">Devro, Inc</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">XXX</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">CARGILL DE HONDURAS</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">XXX</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">N-1831</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">ALCON</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">XXX</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">N/A</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">ADUANA LA MESA</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">07/10/2023 16:16:59 PM</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">XXX</span>
            </td>
          </tr>
          <tr style="border-bottom: 1px solid #ddd; height: 50px">
            <td>
              <span style="font-family: Calibri; font-size: 16px; font-weight: 400; line-height: 19.2px; letter-spacing: 0.02em; text-align: left; color: #3B3B3B;">PR-CH-23-1971</span><br />
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; color: #3B3B3B; font-size: 14px; font-weight: 500; line-height: 16.8px; letter-spacing: 0.02em; text-align: right;">CH-CH-H23-3540</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; color: #3B3B3B; font-size: 14px; font-weight: 500; line-height: 16.8px; letter-spacing: 0.02em; text-align: right;">XXX</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">756481</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; color: #3B3B3B; font-size: 14px; font-weight: 500; line-height: 16.8px; letter-spacing: 0.02em; text-align: right;">Devro, Inc</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">XXX</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">CARGILL DE HONDURAS</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">XXX</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">N-1831</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">ALCON</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">XXX</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">N/A</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">ADUANA LA MESA</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">07/10/2023 16:16:59 PM</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">XXX</span>
            </td>
          </tr>

          <tr style="border-bottom: 1px solid #ddd; background-color: #F5F5F5; height: 50px ">
            <td>
              <span style="font-family: Calibri; font-size: 16px; font-weight: 400; line-height: 19.2px; letter-spacing: 0.02em; text-align: left; color: #3B3B3B;">PR-CH-23-1971</span><br />
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; color: #3B3B3B; font-size: 14px; font-weight: 500; line-height: 16.8px; letter-spacing: 0.02em; text-align: right;">CH-CH-H23-3540</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; color: #3B3B3B; font-size: 14px; font-weight: 500; line-height: 16.8px; letter-spacing: 0.02em; text-align: right;">XXX</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">756481</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; color: #3B3B3B; font-size: 14px; font-weight: 500; line-height: 16.8px; letter-spacing: 0.02em; text-align: right;">Devro, Inc</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">XXX</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">CARGILL DE HONDURAS</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">XXX</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">N-1831</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">ALCON</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">XXX</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">N/A</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">ADUANA LA MESA</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">07/10/2023 16:16:59 PM</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">XXX</span>
            </td>
          </tr>

          <tr style="border-bottom: 1px solid #ddd; height: 50px">
            <td>
              <span style="font-family: Calibri; font-size: 16px; font-weight: 400; line-height: 19.2px; letter-spacing: 0.02em; text-align: left; color: #3B3B3B;">PR-CH-23-1971</span><br />
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; color: #3B3B3B; font-size: 14px; font-weight: 500; line-height: 16.8px; letter-spacing: 0.02em; text-align: right;">CH-CH-H23-3540</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; color: #3B3B3B; font-size: 14px; font-weight: 500; line-height: 16.8px; letter-spacing: 0.02em; text-align: right;">XXX</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">756481</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; color: #3B3B3B; font-size: 14px; font-weight: 500; line-height: 16.8px; letter-spacing: 0.02em; text-align: right;">Devro, Inc</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">XXX</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">CARGILL DE HONDURAS</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">XXX</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">N-1831</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">ALCON</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">XXX</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">N/A</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">ADUANA LA MESA</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">07/10/2023 16:16:59 PM</span>
            </td>
            <td style="text-align:center">
              <span style="font-family: Calibri; font-size: 16px; font-weight: 700; line-height: 19.2px; letter-spacing: 0.02em; text-align: center; color: #3B3B3B;">XXX</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>


    <br />
    <table style="width: 100%; border-collapse: collapse;">
      <tr>
        <td style="vertical-align: bottom; padding: 5px; width: 33.33%">
          <div><span style="font-family: Calibri; font-size: 16px; font-weight: 400; line-height: 19.2px; text-align: left; color: #3B3B3B;">Isabella Gutierrez</span></div>
          <div><span style="font-family: Calibri; font-size: 16px; font-weight: 400; line-height: 19.2px; text-align: left; color: #3B3B3B;">igutierrez@grupovesta.net</span></div>
        </td>
        <td style=" vertical-align: bottom; width: 33.33%; text-align:center">
          <div>
            <span style="font-family: Calibri; font-size: 14px; font-weight: 400; line-height: 28.8px; letter-spacing: 0.02em; text-align: left; color: #3B3B3B;">Honduras - El Salvador - Guatemala - Nicaragua - Costa Rica</span>
          </div>
        </td>
        <td style="vertical-align: bottom; text-align: right; padding: 5px; width: 33.33% ">
          <div style="display:flex; justify-content: end; padding: 5px">
            <img style="height: 60px; width: 60px; padding: 5px" src="/assets/footerUno.png" />
            <img style="height: 60px; width: 60px; padding: 5px" src="/assets/footerDos.png" />
            <img style="height: 60px; width: 60px; padding: 5px" src="/assets/footerTres.png" />
          </div>
        </td>
      </tr>
    </table>
    <br />
  </div>
</body>
</html>-->
